module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeHolder":"Tap to search by Full Name or Case Number"},"es":{"placeHolder":"Toque para buscar por nombre completo o número de caso"}}')
  delete Component.options._Ctor
}
